import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { NFeEntradaItemListarResponse } from '../../responses/repo-dfe/nfe-entrada-item-listar.response';
import { NFeEntradaItemLookupResponse } from '../../responses/repo-dfe/nfe-entrada-item-lookup.response';
import { NFeEntradaItemResponse } from '@shared/services/responses/repo-dfe/nfe-entrada-item.response';

/**
 * Leitura dos itens da nota fiscal de entrada (NFeEntradaItemController da API.RepoDFe).
 * A gravacao passa pelo OrquestradorCompras, nunca por aqui.
 */
@Injectable({ providedIn: 'root' })
export class NFeEntradaItemService extends CommonService {
  private readonly apiUrl: string = environment.urlApiRepoDFe + 'NFeEntradaItem';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public listar(idNFeEntrada: number): Observable<NFeEntradaItemListarResponse> {
    return this.httpClient
      .get<NFeEntradaItemListarResponse>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public obterPorId(idNFeEntradaItem: number): Observable<NFeEntradaItemResponse> {
    return this.httpClient
      .get<NFeEntradaItemResponse>(`${this.apiUrl}/${idNFeEntradaItem}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLookup(): Observable<NFeEntradaItemLookupResponse> {
    return this.httpClient
      .get<NFeEntradaItemLookupResponse>(`${this.apiUrl}/getLookup`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
